// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which transition of a message's active flag fires a `Notification`.
 *
 * ACTIVATED (0) — fire when the message goes active (`ValuedMessage.active` is
 *                 true). Zero value because the offline delivery path has
 *                 always required an active message.
 * CLEARED   (1) — fire when the message goes inactive.
 * BOTH      (2) — fire on either transition.
 *
 * Values are APPEND-ONLY.
 */
export enum TriggerEdge {
  ACTIVATED = 0,
  CLEARED = 1,
  BOTH = 2,
}
